export const HUB_LIVE_STREAM_PATH = "/api/hub/live/stream";

export function unionHubLiveChannels(groups: readonly (readonly string[])[]): string[] {
  const seen = new Set<string>();
  const channels: string[] = [];
  for (const group of groups) {
    for (const raw of group) {
      const channel = raw.trim();
      if (channel === "" || seen.has(channel)) {
        continue;
      }
      seen.add(channel);
      channels.push(channel);
    }
  }
  return channels.sort();
}

export function hubLiveStreamUrl(streamUrl: string, channels: readonly string[]): string {
  const query = channels.length > 0 ? `?channels=${encodeURIComponent(channels.join(","))}` : "";
  return `${streamUrl}${query}`;
}
